import React from 'react';
import styled from 'styled-components';
import { FileText, Search, BookOpen, HeadphonesIcon, ArrowRight } from 'lucide-react';
import { useSiteContent } from '../hooks/useSiteContent';

const Container = styled.section`
  margin-top: 90px;
  min-height: calc(100vh - 90px);
  background: var(--background-light);
`;

const Content = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 4rem 2rem;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h1`
  font-family: var(--font-secondary);
  font-size: 3rem;
  color: var(--primary-blue);
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 1.1rem;
  color: var(--text-light);
  max-width: 600px;
  margin: 0 auto;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const ServiceCard = styled.div`
  background: var(--white);
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  transition: var(--transition);
  border-left: 4px solid var(--gold);

  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-lg);
  }
`;

const IconWrapper = styled.div`
  width: 60px;
  height: 60px;
  background: var(--primary-blue);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--white);
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
`;

const ServiceTitle = styled.h2`
  font-family: var(--font-secondary);
  font-size: 1.5rem;
  color: var(--text-dark);
  margin-bottom: 1rem;
`;

const ServiceDescription = styled.p`
  color: var(--text-light);
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const ServiceLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--primary-blue);
  font-weight: 700;
  transition: var(--transition);

  &:hover {
    color: var(--gold);
    gap: 0.75rem;
  }
`;

const ICON_MAP = {
  FileText,
  Search,
  BookOpen,
  HeadphonesIcon,
  ArrowRight
};

const Services = () => {
  const { content } = useSiteContent('services_page');
  const section = content || {};
  const items = Array.isArray(section.items) ? section.items : [];

  return (
    <Container>
      <Content>
        <Header>
          <Title>{section.title || 'Nos Services'}</Title>
          <Subtitle>
            {section.subtitle || 'Des solutions accessibles et transparentes pour chaque citoyen'}
          </Subtitle>
        </Header>

        <Grid>
          {items.map((service, idx) => {
            const Icon = ICON_MAP[service.icon] || FileText;
            return (
              <ServiceCard key={`${service.title || 'service'}-${idx}`}>
                <IconWrapper><Icon size={22} /></IconWrapper>
                <ServiceTitle>{service.title || ''}</ServiceTitle>
                <ServiceDescription>{service.description || ''}</ServiceDescription>
                <ServiceLink href={service.link || '#'}>
                  {section.ctaLabel || 'Acceder'} <ArrowRight size={18} />
                </ServiceLink>
              </ServiceCard>
            );
          })}
        </Grid>
      </Content>
    </Container>
  );
};

export default Services;
